import { useCallback } from 'react';
import { useTechnicianSessionStore } from '../../store/technicianSession';
import './Header.css';

export const Header = () => {
  const user = useTechnicianSessionStore((state) => state.user);
  const isLoading = useTechnicianSessionStore((state) => state.isLoading);
  const clearSession = useTechnicianSessionStore((state) => state.clearSession);

  const handleLogout = useCallback(async () => {
    await clearSession('Erfolgreich abgemeldet.');
  }, [clearSession]);

  return (
    <header className="app-header">
      <div className="app-header__row">
        <div className="app-header__branding">
          <div className="app-header__title">Inspecta Techniker</div>
          <div className="app-header__subtitle">Sicher unterwegs bei jeder Prüfung</div>
        </div>
        <div className="app-header__session" aria-live="polite">
          {isLoading ? (
            <span className="app-header__session-message">Sitzung wird geladen …</span>
          ) : user ? (
            <div className="app-header__session-info">
              <span className="app-header__session-label">Angemeldet als</span>
              <span className="app-header__session-name">{user.name}</span>
              <button type="button" className="app-header__logout" onClick={handleLogout}>
                Abmelden
              </button>
            </div>
          ) : (
            <span className="app-header__session-message app-header__session-message--warning">
              Keine Techniker-Sitzung aktiv.
            </span>
          )}
        </div>
      </div>
    </header>
  );
};
